<template>
  <div class="range-input">
    <el-input 
      v-model="minValue" 
      :placeholder="minPlaceholder || '最小值'"
      :disabled="disabled"
      :size="size"
      @blur="handleMinBlur"
      @input="handleMinInput"
      class="borderless-input"
    >
      <template slot="prepend" v-if="showLabel">最小值</template>
    </el-input>
    <span class="separator">~</span>
    <el-input 
      v-model="maxValue" 
      :placeholder="maxPlaceholder || '最大值'"
      :disabled="disabled"
      :size="size"
      @blur="handleMaxBlur"
      @input="handleMaxInput"
      class="borderless-input"
    >
      <template slot="prepend" v-if="showLabel">最大值</template>
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'RangeInput',
  props: {
    // 最小值
    min: {
      type: [String, Number],
      default: ''
    },
    // 最大值
    max: {
      type: [String, Number],
      default: ''
    },
    // 最小值占位符
    minPlaceholder: {
      type: String,
      default: '最小值'
    },
    // 最大值占位符
    maxPlaceholder: {
      type: String,
      default: '最大值'
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 输入框尺寸
    size: {
      type: String,
      default: 'small'
    },
    // 是否显示标签
    showLabel: {
      type: Boolean,
      default: false
    },
    // 最小值限制
    minLimit: {
      type: Number,
      default: -Infinity
    },
    // 最大值限制
    maxLimit: {
      type: Number,
      default: Infinity
    },
    // 是否必须是整数
    integer: {
      type: Boolean,
      default: false
    },
    // 最小值不能大于最大值的校验
    validateMinMax: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      minValue: this.min,
      maxValue: this.max
    }
  },
  watch: {
    min(newVal) {
      this.minValue = newVal;
    },
    max(newVal) {
      this.maxValue = newVal;
    }
  },
  methods: {
    // 格式化数值
    formatValue(val) {
      if (val === '' || val === null || val === undefined) return '';
      let num = Number(val);
      if (isNaN(num)) return '';
      if (this.integer) {
        num = Math.floor(num);
      }
      return num;
    },
    
    // 最小值输入
    handleMinInput(val) {
      let formattedVal = this.formatValue(val);
      this.minValue = formattedVal;
      this.$emit('input', { min: this.minValue, max: this.maxValue });
      this.$emit('change', { min: this.minValue, max: this.maxValue });
    },
    
    // 最大值输入
    handleMaxInput(val) {
      let formattedVal = this.formatValue(val);
      this.maxValue = formattedVal;
      this.$emit('input', { min: this.minValue, max: this.maxValue });
      this.$emit('change', { min: this.minValue, max: this.maxValue });
    },
    
    // 最小值失焦校验
    handleMinBlur() {
      // 数值范围限制
      if (this.minValue !== '') {
        let min = Number(this.minValue);
        if (min < this.minLimit) {
          this.minValue = this.minLimit;
          this.$message.warning(`最小值不能小于${this.minLimit}`);
        }
        if (this.validateMinMax && this.maxValue !== '' && min > Number(this.maxValue)) {
          this.minValue = this.maxValue;
          this.$message.warning('最小值不能大于最大值');
        }
      }
      this.$emit('blur', { min: this.minValue, max: this.maxValue });
    },
    
    // 最大值失焦校验
    handleMaxBlur() {
      if (this.maxValue !== '') {
        let max = Number(this.maxValue);
        if (max > this.maxLimit) {
          this.maxValue = this.maxLimit;
          this.$message.warning(`最大值不能大于${this.maxLimit}`);
        }
        if (this.validateMinMax && this.minValue !== '' && max < Number(this.minValue)) {
          this.maxValue = this.minValue;
          this.$message.warning('最大值不能小于最小值');
        }
      }
      this.$emit('blur', { min: this.minValue, max: this.maxValue });
    },
    
    // 获取值
    getValue() {
      return {
        min: this.minValue,
        max: this.maxValue
      };
    },
    
    // 重置
    reset() {
      this.minValue = '';
      this.maxValue = '';
      this.$emit('input', { min: '', max: '' });
    }
  }
}
</script>

<style scoped>
.range-input {
  display: flex;
  align-items: center;
  gap: 8px;
}
.range-input .separator {
  color: #909399;
  font-size: 14px;
}
.range-input >>> .el-input-group__prepend {
  padding: 0 10px;
}
/* 去掉输入框边框 */
.borderless-input >>> .el-input__inner {
  border: none;
  box-shadow: none;
  padding-left: 0;
  padding-right: 0;
  height: 31px!important;
}

/* 去掉 prepend 的边框 */
.borderless-input >>> .el-input-group__prepend {
  border: none;
  background: transparent;
  padding-left: 0;
}

/* 去掉聚焦时的边框效果 */
.borderless-input >>> .el-input__inner:focus {
  border: none;
  box-shadow: none;
}

/* 去掉悬停时的边框 */
.borderless-input >>> .el-input:hover .el-input__inner {
  border: none;
}

/* 如果想去掉整个输入框组的边框 */
.borderless-input >>> .el-input-group {
  border: none;
}
</style>